var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-primary",domProps:{"innerHTML":_vm._s(_vm.ic('plus') + 'Tambah')}})
}
var staticRenderFns = []

export { render, staticRenderFns }